import React from "react"
import styled from "styled-components"

const StyledHeadLine = styled.h4`
  font-size: 1.32em;
  margin-bottom: 20px;
  line-height: 2;
`

const StyledText = styled.p`
  color: ${props => props.theme.colors.text};
  line-height: 1.8;
  & + & {
    margin-top: 1em;
  }
`

export default function Overview() {
  return (
    <>
      <StyledHeadLine>フランソアグループ お客様対応基本方針</StyledHeadLine>
      <StyledText>
        フランソアグループ（以下「当グループ」といいます）は、常にお客様の立場に立ち、商品・サービスの向上に努めております。いただいたご意見・ご要望は真摯に受け止め、社内で共有し、改善に活かしてまいります。
      </StyledText>
      <StyledText>
        一方で、お問い合わせ等の際に、暴力・器物破損、暴言・脅迫、不当な要求、SNS等での誹謗中傷などの迷惑行為があった場合、当グループはこれをカスタマーハラスメント（以下「カスハラ」といいます）とみなします。これらは、当グループで働く社員等の人権を侵害し、安心して働ける職場環境を損なうおそれがあります。
      </StyledText>
      <StyledText>
        当グループは、お客様の多様なニーズやご意見・ご要望を商品・サービスに反映させることで、お客様に選ばれ、長くお付き合いいただける関係を目指しています。そのためにも、カスハラに該当する行為には毅然と対応し、社員等一人ひとりを守ることが重要と考え、以下のとおり方針を定めました。
      </StyledText>
    </>
  )
}
